import { render, staticRenderFns } from "./broadcast.vue?vue&type=template&id=bf8a6a42"
import script from "./broadcast.vue?vue&type=script&lang=js"
export * from "./broadcast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports